import { ComponentProps, ComponentType } from 'react';

import { attachComponentData } from '@backstage/core-plugin-api';

import { PAGE_WRAPPER_KEY } from './composition';

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- variance: providers require concrete props (storageKey, etc.) that a narrower constraint like ComponentType<{ children?: ReactNode }> would reject.
type WrapperLike = ComponentType<any>;

export type PageWrapperProps<C extends WrapperLike> = Omit<
  ComponentProps<C>,
  'children'
> & { component: C };

export const Wrapper = <C extends WrapperLike>(
  _props: PageWrapperProps<C>,
): null => null;

attachComponentData(Wrapper, PAGE_WRAPPER_KEY, true);
